import React from "react";
import { FiExternalLink, FiGithub } from "react-icons/fi";
import Section from "../ui/Section";
import { projects } from "../../data/profile";

function ProjectCard({ project }) {
  return (
    <article className="card card--interactive">
      <div className="project__head">
        <div>
          <h3 className="project__title">{project.title}</h3>
          {project.subtitle && (
            <p className="project__subtitle">{project.subtitle}</p>
          )}
        </div>

        {/* Only render links that exist, so there are never dead anchors. */}
        {(project.repo || project.demo) && (
          <div className="project__links">
            {project.repo && (
              <a
                className="project__icon-link"
                href={project.repo}
                target="_blank"
                rel="noreferrer noopener"
                aria-label={`${project.title} source code on GitHub`}
              >
                <FiGithub aria-hidden="true" />
              </a>
            )}
            {project.demo && (
              <a
                className="project__icon-link"
                href={project.demo}
                target="_blank"
                rel="noreferrer noopener"
                aria-label={`${project.title} live demo`}
              >
                <FiExternalLink aria-hidden="true" />
              </a>
            )}
          </div>
        )}
      </div>

      <p className="project__description">{project.description}</p>

      {project.points?.length > 0 && (
        <ul className="bullets project__bullets">
          {project.points.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
      )}

      <div className="project__tech">
        <ul className="chips">
          {project.tech.map((tech) => (
            <li className="chip chip--accent" key={tech}>
              {tech}
            </li>
          ))}
        </ul>
      </div>
    </article>
  );
}

function Projects() {
  return (
    <Section
      id="projects"
      eyebrow="Projects"
      title="Things I have built"
      subtitle="Applications I designed, built, and deployed end to end."
    >
      <div className="grid grid--2">
        {projects.map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>
    </Section>
  );
}

export default Projects;
